import { LoadVm } from "../../loading/loadvm";
import { ColumnDialogType } from "../../types/columndialogtype";
import { dx } from "../ui-options-types-wrapper";

export class ColumnChooserVm {
	private static columnChoosers: ColumnChooserVm[] = [];
	public static getColumnChooser = (gridId: string) => {
		let foundResults = ColumnChooserVm.columnChoosers.filter((value) => {
			if (value && value.gridId === gridId) {
				return true;
			}
			return false;
		});

		if (foundResults && foundResults.length > 0) {
			return foundResults[0];
		}
		return null;
	}

	public static createInstance = (gridId: string, buttonId: string) => {
		let instance = new ColumnChooserVm(gridId, buttonId);
		ColumnChooserVm.columnChoosers.push(instance);
		return instance;
	}

	private constructor(gridId: string, buttonId: string) {
		this.gridId = gridId;
		this.buttonId = buttonId;
		this.columnsPopupSelectedKeys = ko.observableArray([]);
		this.columnsPopupCurrentSelectedKeys = ko.observableArray([]);
		this.columnsValue = ko.observableArray([]);
		this.columnsPopupItems = ko.observableArray([]);
		this.columnsPopup = ko.pureComputed({
			read: () => {
				return this.columnsPopupItems();
			},
			write: (value) => {
				this.columnsPopupItems(value);
				if (value && value.length > 0) {
					let items = value.filter((item) => {
						return item && item.selected;
					});
					this.columnsPopupSelectedKeys(items.map((item) => {
						return item ? item.id : null;
					}));
					this.columnsPopupCurrentSelectedKeys(this.columnsPopupSelectedKeys());
				} else {
					this.columnsPopupSelectedKeys([]);
					this.columnsPopupCurrentSelectedKeys(this.columnsPopupSelectedKeys());
				}
			}
		});
		this.popupIsVisible = ko.observable(false);
		this.popupOptions = {
			visible: this.popupIsVisible,
			title: "Spaltenauswahl",
			width: "250",
			height: "280",
			shading: false,
			resizeEnabled: true,
			position: { my: "right top", at: "center", of: `#${this.buttonId}` }
		};

		this.show = () => {
			this.columnsPopupCurrentSelectedKeys(this.columnsPopupSelectedKeys());
			this.popupIsVisible(true);
		};

		this.hide = () => {
			this.popupIsVisible(false);
		};

		this.listOptions = {
			showScrollbar: "always",
			selectionMode: "all",
			searchEnabled: true,
			searchExpr: "name",
			showSelectionControls: true,
			selectedItemKeys: this.columnsPopupCurrentSelectedKeys,
			keyExpr: "id",
			dataSource: this.columnsPopup,
			itemTemplate: (itemData: any, itemIndex: any, itemElement: any) => {
				itemElement.append("<b>" + itemData.name + "</b>");
			}
		};

		this.okOptions = {
			text: "OK",
			onClick: () => {
				LoadVm.startLoading({ text: "Spalten werden geladen", showTimer: false });
				this.popupIsVisible(false);
				// TODO (pr) set visibility of all items
				let selectedItemsIndex = this.columnsPopupCurrentSelectedKeys();
				let gridColumns = this.columnsValue();
				let dataGrid = $(`#${gridId}`).dxDataGrid("instance");
				setTimeout(() => {
					for (let itemIndex = 0; itemIndex < gridColumns.length; itemIndex++) {
						let currentSetting = dataGrid.columnOption(itemIndex, "visible");
						if (selectedItemsIndex.indexOf(itemIndex) !== -1 && currentSetting === false ||
							selectedItemsIndex.indexOf(itemIndex) === -1 && currentSetting === true) {
							dataGrid.columnOption(itemIndex, "visible", !currentSetting);
						}
					}
					this.columnsPopupSelectedKeys(this.columnsPopupCurrentSelectedKeys());
					LoadVm.endLoading();
				}, 100);
			}
		};

		this.setColumns = (columns) => {
			this.columnsPopupSelectedKeys([]);
			this.columnsPopupItems([]);
			this.columnsValue([]);
			if (columns && columns.length > 0) {
				let dialogColumns: ColumnDialogType[] = [];
				for (let i = 0; i < columns.length; i++) {
					let value = columns[i];
					if (value && value.showInColumnChooser !== false) {
						dialogColumns.push({
							id: i,
							name: value.caption,
							selected: value.visible
						});
					}
				}
				this.columnsPopup(dialogColumns);
			} else {
				this.columnsPopup([]);
			}
			this.columnsValue(columns);
		};
	}

	public popupOptions: any;
	public popupIsVisible: KnockoutObservable<boolean>;
	public okOptions: any;
	public listOptions: dx.ListOptions;
	public buttonId: string;
	public gridId: string;
	public columnsPopupSelectedKeys: KnockoutObservableArray<string | number>;
	public columnsPopupCurrentSelectedKeys: KnockoutObservableArray<string | number>;
	public columnsPopupItems: KnockoutObservableArray<ColumnDialogType>;
	public columnsPopup: KnockoutComputed<ColumnDialogType[]>;
	public columnsValue: KnockoutObservableArray<any>;

	public setColumns: (columns: any[]) => void;
	public show: () => void;
	public hide: () => void;
}